import { render, staticRenderFns } from "./CompanyTabDetails.vue?vue&type=template&id=39faea11&scoped=true&"
import script from "./CompanyTabDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyTabDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39faea11",
  null
  
)

export default component.exports